<div class="center-float">
    <ul id="alpha-grid">
        {#each alphas as alpha, index (alpha.id)}
            <li>
                <input type="radio" name="alpha" value="{alpha.name}" on:click={() => alphaClicked(alpha.name)} checked> {alpha.name}
            </li>
        {:else}
            No pairs defined!
        {/each}
    </ul>
    <div id="contains-select">
        <span>Starts with</span>
        <input type="text"  id="contains-input" on:change={getContains}>
        <button class="select-button" on:click={getContains}>Search</button>
    </div>
</div>

<style>
    #alpha-grid {
        list-style-type: none;
        display: grid;
        grid-template-columns: auto auto auto auto auto;
        justify-content: start;
        gap: 1vh;
    }
    .center-float {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    #contains-input {
        width: 7vw;
    }
    #contains-select {
        display: flex;
        flex-direction: row;
        gap: 0.5vw;
    }
</style>

<script>
    import { get } from 'svelte/store';
	import { state } from './data-store';
    import { getValue, setValue } from './utilities';

    export let alpha;
    var contains = '';
    let alphas = getAlphas();
    $: alpha = alphaChanged(alpha);

    function alphaChanged(alpha) {
        let buttons = document.getElementsByName('alpha');
        buttons.forEach((button) => {
            if (button.value == alpha) {
                button.checked = true;
            }
        })
        return alpha;
    }

    function getAlphas() {
        let letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
        letters.push('All');
        let alphas = [];
        for (let index = 0; index < letters.length; index++) {
            alphas.push({
                id: index, name: letters[index], checked: true
            })
        }
        return alphas;
    }

    function getContains() {
        alphaClicked(getValue('contains-input'))
    }

    function alphaClicked(text) {
        if (text == '') {
            return
        };
        let state_store = get(state)
        state_store.alpha = text
        state.set(state_store)
        setValue('contains-input', '')
    }
</script>